import { Modal, Row, Col, Button } from 'react-bootstrap';
import React from 'react';
const VPNModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} style={{ zIndex: '10000000000' }}>
    <Modal.Body className='rtl' style={{ fontSize: '.9rem' }}>
      <p>مشتری گرامی، قبل از ورود به درگاه پرداخت از خاموش بودن vpn خود اطمینان حاصل فرمایید.</p>
    </Modal.Body>
    <Modal.Footer>
      <Row style={{ width: '100%', margin: '0px' }}>
        <Col style={{ width: '50%', padding: '0px 5px' }}>
          <Button className=' border-0 color-white rounded p-2 modal-buttons' onClick={onHide}>
            <span>متوجه شدم</span>
          </Button>
        </Col>
      </Row>
    </Modal.Footer>
  </Modal>
);

export default VPNModal;
